import { QueryClient } from '@tanstack/react-query';

// Phase 3: Shared query client for heavy server-state caching.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 60 * 1000,
    },
  },
});
